import { useQuery } from 'react-query';
import { getSocialMediaLinks } from 'lib/api';

export const useGetSocialMediaLinks = () => {
  return useQuery(['social-media-links'], () => getSocialMediaLinks(), {
    refetchOnMount: true,
  });
};
